import { isValidElement } from 'react';
import deepFilter from './deepFilter.js';

var onlyValid = function onlyValid(children) {
  return deepFilter(children, function (child) {
    return isValidElement(child);
  });
};

export default onlyValid;